import request from '@/utils/request'

const userApi = {
  Login: '/biz/admin/login',
  Logout: '/biz/admin/logout',
  Register: '/biz/admin/register',
  // get my info
  UserInfo: '/biz/admin/get-user-info'
}

export function login(nation,accountNo, password, captchaVerification, userType, loginType, device) {
  const data = {
    nation, accountNo, password, captchaVerification , userType, loginType, device
  }
  return request({
    url: userApi.Login,
    method: 'post',
    data: data
  })
}

// 注册方法
export function register (data) {
  return request({
    url: userApi.Register,
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function getInfo () {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout () {
  return request({
    url: userApi.Logout,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 获取验证码
export function getCodeImg () {
  return request({
    url: '/biz/admin/get-pic-captcha',
    method: 'get'
  })
}
// 获取验证码
export function getSmsCode(data) {
  return request({
    url: '/biz/admin/get-phone-valid-code',
    method: 'get',
    params: data
  })
}
